import { EnvironmentSmataInfo } from './environment.model';

export const environment: EnvironmentSmataInfo = {
  name: 'Netstrata',
  production: false,
  envName: 'feature',
  apiUrl: 'https://api.ss-edge-feature.cloud.netstrata.com.au',
};
